import * as React from "react"
export const ToolbarBackArrow = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
        height={20}
         viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <g
      stroke="#6C757D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    >
      <path d="M2.187 5.795h10.938s5.208 0 5.208 5.128c0 5.77-5.208 5.77-5.208 5.77H4.048" />
      <path d="M5.313 9.609 1.667 5.795 5.313 1.98" />
    </g>

  </svg>
)
